import { SVGProps, Ref, forwardRef } from 'react';

export const UserSingleBanOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.667 9.334a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666m-1.768 2.552a1.9 1.9 0 0 0-.165.781l.01.197a1.933 1.933 0 0 0 1.923 1.736l.197-.01c.206-.021.4-.076.582-.156zm1.768-1.152c-.276 0-.539.058-.776.162l2.544 2.546c.105-.237.165-.499.165-.775l-.01-.197a1.93 1.93 0 0 0-1.726-1.726z"
                    fill="currentColor"
                />
                <path
                    d="M6.497 10c.506 0 1.011.042 1.503.133v1.43a6.7 6.7 0 0 0-1.503-.163c-1.308 0-2.465.327-3.27.992-.615.507-1.141 1.308-1.319 2.608H.5c.419-3.725 3.207-5 5.997-5"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.77 1.006c2.607.111 3.597 1.814 3.713 3.62l.012.374c0 2-1 4-4 4s-4-2-4-4l.012-.374C2.627 2.758 3.682 1 6.495 1zM6.496 2.4c-1.163 0-1.737.372-2.05.746-.35.42-.55 1.062-.55 1.854s.2 1.434.55 1.854c.313.374.887.746 2.05.746s1.738-.372 2.05-.746c.35-.42.55-1.062.55-1.854s-.2-1.434-.55-1.854c-.312-.374-.887-.746-2.05-.746"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
UserSingleBanOutlinedSize16Glyph.displayName = 'UserSingleBanOutlinedSize16Glyph';
